import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AnyObject, ErrorMessage, FieldOption, MrExpression } from '@mri/types';

@Component({
  selector: 'app-field-expression',
  templateUrl: './field-expression.component.html',
  styleUrl: './field-expression.component.scss'
})
export class FieldExpressionComponent implements OnInit {

  private _classSet: Set<string> = new Set<string>();
  private _value: MrExpression;

  @Output() valueChange = new EventEmitter<MrExpression>;
  @Input() placeholder?: string;
  @Input() label: string;
  @Input() errors?: Array<ErrorMessage>;
  @Input() mode?: string;
  @Input() inputOptionsUrl?: string;
  @Input() inputOptionsFilter?: Record<string, AnyObject>;
  @Input() hideMode?: boolean;

  get classes(): string {
    return [...this._classSet].join(' ');
  }

  @Input() set value(value: MrExpression) {
    if(!value) return;
    this._value = value;
    this.mode = value?.type;
  }

  get value() {
    return this._value;
  }

  get options(): AnyObject {
    return {
      lineNumbers: true,
      mode: 'javascript',
      height: 'auto',
      lint: true,
      viewportMargin: Infinity,
      autoCloseBrackets: true,
      lineWrapping: true,

    };
  }

  get operationOptions(): Array<FieldOption> {
    return [
      {
        label: 'Igual',
        value: 'eq'
      },
      {
        label: 'Diferente',
        value: 'ne'
      },
      {
        label: 'Mayor',
        value: 'gt'
      },
      {
        label: 'Mayor o igual',
        value: 'gte'
      },
      {
        label: 'Menor',
        value: 'lt'
      },
      {
        label: 'Menor o igual',
        value: 'lte'
      },
      {
        label: 'En',
        value: 'in'
      },
      {
        label: 'No en',
        value: 'nin'
      },
      {
        label: 'Expresion regular',
        value: 'regex'
      }
    ];
  }


  onChange(event: AnyObject) {
    this.valueChange.emit(event.target.value);
  }

  onChangeInput(event: string) {
    if (!this._value) this._value = {} as MrExpression;
    this._value.input = event;

    this.valueChange.emit(this.value);
  }

  onChangeInputTarget($event: AnyObject) {
    console.log({$event});
    const event = $event.target.value;

    if (!this._value) this._value = {} as MrExpression;
    this._value.input = event;

    this.valueChange.emit(this.value);
  }

  onChangeScriptTarget(event: string) {

    if (!this._value) this._value = {} as MrExpression;
    this._value.input = event;

    this.valueChange.emit(this.value);
  }


  onChangeOperation(event: string) {
    if (!this._value) this._value = {} as MrExpression;
    this._value.operation = event as 'eq';

    this.valueChange.emit(this.value);
  }

  onChangeValue(event: string) {
    if (!this._value) this._value = {} as MrExpression;
    this._value.value = event;

    this.valueChange.emit(this.value);
  }

  onChangeMode($event: AnyObject) {
    const event = $event.target.value;

    if (!this._value) this.value = {} as MrExpression;

    this._value.type = event as 'simple';

    this.valueChange.emit(event === '' ? this._value : undefined);
  }

  onFocus() {
    this._classSet.add('card-focus');
  }

  onBlur() {
    this._classSet.delete('card-focus');
  }

  ngOnInit(): void {
    if (this.value) return;

    this.value = {
      type: (this.mode as 'simple') || 'simple',
      value: '',
      input: ''
    };
  }


}
